import { utils, writeFile } from "xlsx";
import BlockLoader from "../../../../../../../Components/Loaders/BlockLoader";
import { useAppSelector } from "../../../../../../../Hooks/redux/useAppSelector";
import {
  IOrdersStatisticItem,
  useGetStatisticQuery,
} from "../../../../../../../Store/APIs/Campaign.api";
import basicModal from "../../../../../../../Theme/modalsElements.module.scss";
import BasicButton from "../../../../../../../UI/BasicButton";
import StatisticFilter from "../../StatisticFilter/StatisticFilter";
import StatisticTable from "../../tables/StatisticTable/StatisticTable";
import listStyles from "../Lists.module.scss";
import styles from "./Statistic.module.scss";

const EXPORT_TABLE_COLUMNS: {
  key: keyof IOrdersStatisticItem;
  title: string;
}[] = [
  {
    key: "application_name",
    title: "Application",
  },
  {
    title: "Store",
    key: "application_store_id",
  },
  {
    title: "Countries",
    key: "countries",
  },
  {
    title: "Keywords",
    key: "keywords",
  },
  {
    title: "Active Campaigns",
    key: "activeCampaigns",
  },
  {
    title: "Completed Campaigns",
    key: "completedCampaigns",
  },
  {
    title: "Cancelled Campaigns",
    key: "cancelledCampaigns",
  },
  {
    title: "Installs",
    key: "installsCount",
  },
  {
    title: "Rates",
    key: "ratesCount",
  },
  {
    title: "Cost",
    key: "cost",
  },
];

const StatisticAppsList = () => {
  const { dateStart, dateStop, selectedApps } = useAppSelector(
    (state) => state.myOrdersStatisticSlice,
  );

  const {
    data = [],
    isLoading,
    isSuccess,
  } = useGetStatisticQuery({
    dateStart,
    dateStop,
    apps: selectedApps.map((app) => app.id),
  });

  const handleExport = () => {
    if (data.length) {
      const headerRow = [...EXPORT_TABLE_COLUMNS.map((column) => column.title)];
      const worksheetData = [headerRow];

      data.forEach((row) => {
        const sheetRow: string[] = [];

        EXPORT_TABLE_COLUMNS.forEach((col) => {
          let newCell;

          if (col.key === "application_store_id") {
            newCell = row[col.key].includes(".") ? "Play market" : "App store";
          } else if (col.key === "cost") {
            newCell = row[col.key].toFixed(2);
          } else {
            newCell = row[col.key];
          }

          sheetRow.push(String(newCell));
        });

        worksheetData.push(sheetRow);
      });

      const ws = utils.aoa_to_sheet(worksheetData);
      const wb = utils.book_new();

      utils.book_append_sheet(wb, ws, `Data`);

      writeFile(wb, `appreport_${dateStart}-${dateStop}.xlsx`);
    }
  };

  return (
    <div className={listStyles.wrapper}>
      <h3 className={basicModal.modal_title + " " + styles.title}>Statistic</h3>
      <StatisticFilter />
      <div className={listStyles.table_block}>
        {isLoading ? <BlockLoader size={"lg"} /> : null}
        {!isLoading && !!data.length && isSuccess ? (
          <StatisticTable statisticList={data} />
        ) : null}
      </div>
      <div className={listStyles.export_block}>
        <BasicButton
          onClick={handleExport}
          size={"md"}
          text={"Export XLXS"}
          variant={"blue"}
          disabled={!isSuccess || !data.length}
        />
      </div>
    </div>
  );
};

export default StatisticAppsList;
